import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';
import { DateProps } from '..';

export interface DateInputProps extends DateProps {}

const InputComponent: React.FC<DateInputProps> = props => {
  const {
    id,
    name,
    placeholder = '',
    required = false,
    disabled = false,
    value = '',
    min,
    max,
    onChange,
    onBlur,
    onFocus,
    className = '',
    ...ariaProps
  } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    // Ensure the date picker opens when clicking anywhere on the input
    if (inputRef.current && !disabled) {
      try {
        // Check if the input is not readOnly before calling showPicker
        if (!inputRef.current.readOnly) {
          inputRef.current.showPicker?.();
        }
      } catch (error) {
        // Log for debugging but don't break the UI
        console.warn('Unable to open date picker:', error);
      }
    }
  };

  return (
    <input
      ref={inputRef}
      type="date"
      id={id}
      name={name}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      value={value}
      min={min}
      max={max}
      autoComplete="off"
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={handleClick}
      className={clsx(
        'peptalk-form-element peptalk-date',
        !!value && 'has-value',
        className
      )}
      {...ariaProps}
    />
  );
};

export const Input: React.FC<DateInputProps> = (props: DateInputProps) => {
  const Component = useCustomComponent({
    componentName: 'DateInput',
    Component: InputComponent,
  });

  return <Component {...props} />;
};
